const $inject = ['$scope', '$routeParams', 'settingsService', 'dataService'];

const lbaSelectCtrl = function ($scope, $routeParams, settingsService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.getOptions = getOptions;
  vm.addSelected = addSelected;
  vm.items = settingsService.options[vm.settings.optionsAt];
  vm.onChange = onChange;
  vm.dataService = dataService;

  if(vm.settings.filterByKey){
    const filterOptionsBy = dataService.spiltDataAt(vm.settings.filterByKey, $routeParams);
    const key = _.get(dataService.data.activeItem, filterOptionsBy);
    vm.items = vm.items[key];
  }

  // UI SELECT DOESN'T AUTO SELECT NUMBERS SO NEED TO CONVERT TO STRINGS...
  if (vm.settings.optionsNumbers) {
    vm.items.map(item => {
      item.value = '' + item.value;

      return item;
    });

    vm.data = '' + vm.data;
  }

  if(vm.settings.defaultOption && vm.data === undefined){
    vm.data = vm.settings.defaultOption;
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function getOptions(options, userInput) {
    const opts = angular.copy(options);
    if (userInput.length > 0) {
      opts.unshift(userInput);
    }
    return opts;
  }

  function addSelected(item) {
    if (vm.items.indexOf(item) === -1) {
      vm.items.unshift(item);
    }
  }

  function onChange(){
    $scope.$emit(vm.settings.dataAt + '_ChangeEvent', vm.data);
  }

};

lbaSelectCtrl.$inject = $inject;

export default lbaSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaSelect/lbaSelectCtrl.js